export default __webpack_public_path__ + "static/media/portfolio.d1cc2877.png";